import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-response-dialog',
  standalone: true,
  imports: [],
  templateUrl: './response-dialog.component.html',
  styleUrl: './response-dialog.component.scss',
})
export class ResponseDialogComponent {
  constructor(
    private dialog: MatDialogRef<ResponseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  closeDialog(): void {
    this.dialog?.close();
  }
}
